import { InfiniteApproval } from "@src/components/Swap/SettingsView/InfiniteApproval";
import { Delivery } from "./Delivery";
import { Slippage } from "./Slippage";

export const SettingsView = () => {
  return (
    <div className="flex flex-col gap-5 px-4">
      <Delivery />
      <InfiniteApproval />
      <Slippage />
    </div>
  );
};
